import './style.less';

export default function($stateParams, $log, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.stateParams = $stateParams;

  vm.loggedIn = ProfileClass.loggedIn;

  function activate() {
    $log.debug('Self Study Top Nav Component Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selfStudy/topNav/controller.js